var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 386,
    viewBox: "-64 15 406 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Head / 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M217.11 383.69L215.398 324.966C215.398 324.966 287.211 330.648 302.574 322.718C302.574 322.718 319.134 236.223 298.502 171.287L146.957 153.673L136.175 240.266C131.07 225.303 91.2253 208.158 80.2111 229.584C56.3467 276.011 141.681 307.271 141.681 307.271L133.016 384.397",
    fill: "#5E93D1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    opacity: 0.399344,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.398 324.966L166.975 314.648L215.166 346.998L215.398 324.966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.343 229.001L272.077 269.653L252.022 269.906L255.343 229.001Z",
    fill: "#2437A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.263 240.553C237.261 246.028 233.601 251.268 228.093 252.257C222.583 253.248 217.311 249.612 216.314 244.139C215.317 238.665 218.976 233.424 224.484 232.434C229.994 231.445 235.268 235.079 236.263 240.553Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.894 240.553C289.891 246.028 286.232 251.268 280.724 252.257C275.214 253.248 269.942 249.612 268.945 244.139C267.947 238.665 271.607 233.424 277.115 232.434C282.625 231.445 287.899 235.079 288.894 240.553Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.535 281.417C234.535 281.417 241.544 292.711 255.428 291.754L234.535 281.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 14",
    d: "M234.535 281.417C234.535 281.417 241.544 292.711 255.428 291.754",
    stroke: "#252535",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M107.533 221.758C100.804 196.891 76.4503 105.102 79.3192 89.4325C82.6402 71.2724 95.3626 48.9793 160.733 25.5969C216.119 5.78613 247.362 20.1314 256.826 32.3376C271.226 50.9108 298.502 171.289 298.502 171.289C298.502 171.289 275.933 187.247 195.902 184.495C195.902 184.495 206.981 232.37 161.565 229.619C161.565 229.619 166.432 245.742 144.454 250.813C132.395 232.18 116.391 224.649 107.533 221.758Z",
    fill: "#19141E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.6ed26080.svg";
export { ForwardRef as ReactComponent };